package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.navigation.NavParams
import org.moxultimate.topwithmox.product.data.ProductContentResponse
import org.moxultimate.topwithmox.productcrud.update.ProductUpdatePage

@InitRoute
fun initProductUpdateRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Edit Product Content"))

    val urlParams: dynamic = js("new URLSearchParams(window.location.search)")
    fun param(key: String): String = (urlParams.get(key) as? String).orEmpty()

    val content = ProductContentResponse(
        id            = param(NavParams.ID).toLongOrNull() ?: 0L,
        title         = param(NavParams.TITLE),
        description   = param(NavParams.DESCRIPTION).ifEmpty { null },
        videoLink     = param(NavParams.VIDEO_LINK).ifEmpty { null },
        tags          = param(NavParams.TAGS).ifEmpty { null },
        type          = param(NavParams.TYPE).ifEmpty { null },
        thumbnailPath = param(NavParams.THUMBNAIL_PATH).ifEmpty { null },
    )
    ctx.data.add(content)
}

@Page(routeOverride = "productupdate")
@Layout(".components.layouts.PageLayout")
@Composable
fun ProductUpdateRoute() {
    val ctx = rememberPageContext()
    val content = ctx.data.getValue<ProductContentResponse>()
    ProductUpdatePage(content = content)
}
